// react and js
import { React, useContext } from "react";
import { useTranslation } from "react-i18next";

// mui
import { Box, Grid, Stack } from "@mui/material";

// components
import CardOutlet from "../../../components/CardOutlet";

// hooks
import appContext from "../../../hooks/appContext";

// i18n
import { localizeWebsiteUrl, DEFAULT_LANGUAGE } from "../../../i18n";

// layouts

// pages

// theme
import { B1Small } from "../../../theme/styled";

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function GettingStarted() {
  const { t, i18n } = useTranslation();
  const activeLang = i18n.language || DEFAULT_LANGUAGE;
  // eslint-disable-next-line
  const { stateStorage } = useContext(appContext);

  return (
    <CardOutlet
      variant="outlet"
      backgroundProp="#F2F2F2"
      title={t("stepper.gettingStarted")}
      subheader={t("distributionTickData.gettingStarted.subheader")}
      mainOutlet={
        stateStorage.distributionTickDataPlan !== null ? (
          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 3,
            }}
          >
            <Grid item xs={12}>
              <Stack sx={{ width: "100%" }}>
                <Box>
                  <B1Small
                    sx={{ mb: 2 }}
                    fullWidth
                    variant="contained"
                    href={localizeWebsiteUrl(
                      `${process.env.REACT_APP_URL_FRONTEND_DASHBOARD}/subscriptions`,
                      activeLang
                    )}
                    target="_blank"
                  >
                    {t("distributionTickData.gettingStarted.manageSubscriptionButton")}
                  </B1Small>
                </Box>

                <Box>
                  <B1Small
                    fullWidth
                    variant="contained"
                    href={localizeWebsiteUrl(
                      `${process.env.REACT_APP_URL_FRONTEND_WEBSITE}/manuals/mt5-tick-data`,
                      activeLang
                    )}
                    target="_blank"
                  >
                    {t("distributionTickData.gettingStarted.userManualButton")}
                  </B1Small>
                </Box>
              </Stack>
            </Grid>
          </Grid>
        ) : null
      }
    />
  );
}
